var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('default-layout',{staticClass:"not-found-page"},[_c('div',{staticClass:"centered"},[_c('h1',[_c('i',{staticClass:"not-found-icon nc-icon nc-puzzle-10"}),_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v("The page you requested could not be found.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3de6225e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GeneralViews/NotFoundPage.vue
// module id = Ondn
// module chunks = 24